module.exports = __webpack_public_path__ + "static/img/daiyunwei.13181b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daiyunwei.png
// module id = LfS+
// module chunks = 1